import { Legacyprofile, ProfileList as ProfileListData, Publicprofile } from '@/payload-types'
import LegacyRegularPostProfileCard from '@/components/legacy-profile-profile-card/regularPostProfileCard'
import LegacyCompactPostProfileCard from '@/components/legacy-profile-profile-card/compactPostProfileCard'
import LegacyFeaturedPostProfileCardComponent from '@/components/legacy-profile-profile-card/featuredPostProfileCard'
import FeaturedPostProfileCardComponent from '../public-profile-card/featuredPostProfileCard'
import { SortProfileListByName } from '@/lib/profileFunction'
import RegularPostProfileCard from '../public-profile-card/regularPostProfileCard'
import CompactPostProfileCard from '../public-profile-card/compactPostProfileCard'
interface IProps {
  profileListData: ProfileListData | null
  featuredSection?: boolean
}

export const ProfileList = ({ profileListData, featuredSection = false }: IProps) => {
  if (profileListData?.profileList) {
    const profileList = SortProfileListByName(profileListData)
    if (featuredSection) {
      return profileList?.map((item) => {
        if (item.profile && item.keyProfile) {
          if (item.profile.relationTo === 'publicprofiles') {
            return (
              typeof item.profile.value === 'object' &&
              item.profile.value._status === 'published' && (
                <FeaturedPostProfileCardComponent
                  profileData={item.profile.value as Publicprofile}
                  key={item.id}
                />
              )
            )
          } else {
            return (
              <LegacyFeaturedPostProfileCardComponent
                profileData={item.profile.value as Legacyprofile}
                key={item.id}
              />
            )
          }
        }
      })
    } else {
      const listFormat = profileListData?.listFormat

      if (listFormat === 'regularFormat') {
        return (
          <div className="flex flex-wrap justify-evenly md:block">
            {profileList?.map((item) => {
              if (item.profile) {
                if (item.profile.relationTo === 'publicprofiles') {
                  return (
                    typeof item.profile.value === 'object' &&
                    item.profile.value._status === 'published' && (
                      <RegularPostProfileCard
                        profileData={item.profile.value as Publicprofile}
                        key={item.id}
                      />
                    )
                  )
                } else {
                  return (
                    <LegacyRegularPostProfileCard
                      profileData={item.profile.value as Legacyprofile}
                      key={item.id}
                    />
                  )
                }
              }
            })}
          </div>
        )
      } else if (listFormat === 'compactFormat') {
        return (
          <div>
            <div className="flex flex-wrap justify-center mr-[-5.5px]">
              {profileList?.map((item) => {
                if (item.profile) {
                  if (item.profile.relationTo === 'publicprofiles') {
                    return (
                      typeof item.profile.value === 'object' &&
                      item.profile.value._status === 'published' && (
                        <CompactPostProfileCard
                          profileData={item.profile.value as Publicprofile}
                          key={item.id}
                        />
                      )
                    )
                  } else {
                    return (
                      <LegacyCompactPostProfileCard
                        profileData={item.profile.value as Legacyprofile}
                        key={item.id}
                      />
                    )
                  }
                }
              })}
            </div>
          </div>
        )
      }
    }
  }
}

export default ProfileList
